export default class RandomUtils {

	static getUUID() {
		return typeof window.crypto.randomUUID == "function" ? window.crypto.randomUUID() : Math.random().toString().replace("0.", "");
	}
}